
import { Component, Emit, Vue } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { email, maxLength, required } from 'vuelidate/lib/validators';
import { emailLocalPartMaxLength } from '@/mixins/validations/email-validation';
import { ResetPasswordRequestFormData } from '@/model/ResetPassword';
import { mapGetters } from 'vuex';
import { ApiError } from '@/model/ApiError';
import FormInput from '@/components/form/FormInput.vue';

@Component({
    components: {
        FormInput,
    },
    computed: mapGetters({
        error: 'resetPasswordStorage/getError',
    }),
})
export default class ResetPasswordRequestForm extends Vue {
    formData = {
        email: '',
    } as ResetPasswordRequestFormData;

    submitted = false;

    error!: ApiError | null;

    @Validations()
    validations = {
        formData: {
            email: {
                email,
                required,
                maxLength: maxLength(80),
                localPartMaxLength: (value: string): boolean =>
                    emailLocalPartMaxLength(value),
            },
        },
    };

    @Emit()
    submit(): ResetPasswordRequestFormData {
        return this.formData;
    }

    onSubmit(): void {
        this.submitted = true;

        this.$v.formData.$touch();
        if (!this.$v.$invalid) {
            this.submit();
        }
    }
}
